<template>
  <div>
    <div>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">อัพเดทสถานะเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div class="pa-2">
        <v-card elevation="8">
          <div class="pt-4 pl-4 pr-4">
            <router-link to="/addpurchase">
              <v-btn class="grad-success-bg white--text" style="width: 100%;height: 45px">+
                สร้างรายการสั่งซื้อใหม่</v-btn>
            </router-link>
          </div>
          <div class="pa-3 pt-7">
            <v-divider />
            <v-tabs grow show-arrows color="#8cc63e">
              <v-tab @click="page(1)" style="font-size: 18px">กำลังดำเนินการ</v-tab>
              <v-tab @click="page(2)" style="font-size: 18px">เสร็จสิ้น</v-tab>
            </v-tabs>
            <v-divider />
          </div>
          <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="pa-2">
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
                  hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="purchaseHeaders" :items="purchaseAll" :footer-props="footer_Props"
               :search="search" mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.po_code }}</td>
                    <td>{{ diffTH(dataDetail.item.po_date) }}</td>
                    <td>{{ dataDetail.item.supplier_name }}</td>
                    <td>
                      <div v-if="dataDetail.item.sup_department !== null">{{ dataDetail.item.sup_department }}</div>
                      <div v-else>-</div>
                    </td>
                    <td>
                      <div v-if="dataDetail.item.status === 0 && dataDetail.item.status_approve === 1"
                        style="color: #8cc63e">เสร็จสิ้น</div>
                      <div v-else-if="dataDetail.item.status === 0" style="color: #fdac39">กำลังดำเนินการ</div>
                      <div v-else-if="dataDetail.item.status === 1" style="color: #ea2222">ค้างรับ</div>
                      <div v-else-if="dataDetail.item.status === 2" style="color: #ea2222">ยกเลิก</div>
                      <div v-else style="color: #8cc63e">เสร็จสิ้น</div>
                    </td>
                    <!-- <td class="text-center" v-if="title_add === 1">
                      <v-btn small height="42"
                        v-if="dataDetail.item.status_approve == 0 && $store.state.status === 1 && dataDetail.item.status === 0"
                        @click="order_approved(dataDetail.item.po_id)" class="white--text mr-1 mb-1"
                        style="background-color:#277a2a" title="อนุมัติ">
                        <v-icon>mdi-check-decagram-outline</v-icon>
                      </v-btn>
                      <div v-else style="color: #8cc63e">อนุมัติแล้ว</div>
                    </td> -->
                    <td class="pa-3">
                      <!-- <v-btn small height="42" @click="getDetails(dataDetail.item.po_id)"
                        class="grad-success-bg white--text mr-1 mb-1" title="รายละเอียด">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn> -->
                      <v-btn small height="42" v-if="dataDetail.item.status === 0 && dataDetail.item.status_approve === 0"
                        @click="getEdit(dataDetail.item.po_id)" class="grad-warning-bg white--text mr-1 mb-1"
                        title="แก้ไข">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>
                      <v-btn small height="42" v-if="dataDetail.item.status === 0 && dataDetail.item.status_approve === 0"
                        @click="delAlert(dataDetail.item.po_id)" class="grad-danger-bg white--text mb-1" title="ลบ">
                        <v-icon>mdi-delete-empty-outline</v-icon>
                      </v-btn>
                      <v-btn small height="42" v-if="dataDetail.item.status !== 2"
                        @click="getPrinter(dataDetail.item.po_id)" class="grad-main-bg white--text ml-1 mb-1"
                        title="พิมพ์ใบเสร็จ">
                        <v-icon>mdi-printer</v-icon>พิมพ์
                      </v-btn>
                      <v-btn small height="42" v-if="dataDetail.item.status === 1"
                        @click="cancel_po(dataDetail.item.po_id)" class="grad-danger-bg white--text ml-1 mb-1"
                        title="ยกเลิกใบสั่งซื้อ">
                        <v-icon>mdi-text-box-remove-outline</v-icon>ยกเลิกใบสั่งซื้อ
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card>
        <v-dialog v-model="po_cancel" max-width="900">
          <v-card>
            <v-form ref="add_form" @submit.prevent="save_cancel_po">
              <v-card-title>
                คำเตือน
              </v-card-title>
              <v-card-text>
                <div class="ma-2">
                  คุณต้องการยกเลิกใบสั่งซื้อหรือไม่
                </div>
                <div class="ma-3 ml-1 ">
                  <v-text-field color="#86bc3a" label="หมายเหตุการยกเลิก" prepend-inner-icon="mdi-message-bulleted"
                    v-model="cancel_modal.cancel_note" hide-details="auto" outlined></v-text-field>
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn large class="grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                  ตกลง
                </v-btn>
                <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px"
                  @click="po_cancel = false">
                  ยกเลิก
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import Swal from "sweetalert2";
import { diffDateTH } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "PurchaseOrder",
  data() {
    return {
      loading_page: false,
      search: null,
      alert_success: false,
      alert_danger: false,
      item_page: -1,
      po_cancel: false,
      cancel_modal: {
        cancel_id: null,
        cancel_note: null,
      },
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      purchaseHeaders: [
        {
          text: 'เลขที่',
          value: 'po_code',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันที่',
          value: 'po_date',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'อนุมัติ',
          value: 'status',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'อนุมัติ',
          value: 'status_approve',
          sortable: false,
          fixed: true,
          width: '300px',
          align: 'center',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '300px',
        },
      ],
      purchaseAll: [],
    }
  },
  methods: {
    async page(type) {
      this.title_add = type
      if (type === 1) {
        this.purchaseHeaders = [
          {
            text: 'เลขที่',
            value: 'po_code',
            fixed: true,
            width: '150px',
          },
          {
            text: 'วันที่',
            value: 'po_date',
            fixed: true,
            width: '150px',
          },
          {
            text: 'ซัพพลายเออร์',
            value: 'supplier_name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'แผนก',
            value: 'sup_department',
            fixed: true,
            width: '180px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '150px',
          },
          // {
          //   text: 'อนุมัติ',
          //   value: 'status_approve',
          //   sortable: false,
          //   fixed: true,
          //   width: '300px',
          //   align: 'center',

          // },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '300px',
          },
        ]
        this.getPurchaseAll()
      }
      else {
        this.purchaseHeaders = [
          {
            text: 'เลขที่',
            value: 'po_code',
            fixed: true,
            width: '150px',
          },
          {
            text: 'วันที่',
            value: 'po_date',
            fixed: true,
            width: '150px',
          },
          {
            text: 'ซัพพลายเออร์',
            value: 'supplier_name',
            fixed: true,
            width: '300px',
          },
          {
            text: 'แผนก',
            value: 'sup_department',
            fixed: true,
            width: '180px',
          },
          {
            text: 'สถานะ',
            value: 'status',
            sortable: false,
            fixed: true,
            width: '150px',
          },
          {
            text: 'จัดการ',
            value: '',
            sortable: false,
            fixed: true,
            width: '300px',
          },
        ]
        this.getPurchaseSuccess()
      }
    },
    delAlert(id) {
      Swal.fire({
        title: 'คุณต้องลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.getDelete(id)
        }
      });
    },
    diffTH: function (value) {
      return diffDateTH(value)
    },
    getPurchaseAll() {
      this.loading_page = true
      HTTP.post('/purchaseorders/getpoall')
        .then((res) => {
          if (res.data.success === true) {
            this.loading_page = false
            this.purchaseAll = res.data.object
          }
        })
    },
    getPurchaseSuccess() {
      this.loading_page = true
      HTTP.post('/purchaseorders/getpoallsuccess')
        .then((res) => {
          if (res.data.success === true) {
            this.loading_page = false
            this.purchaseAll = res.data.object
          }
        })
    },
    getDetails(id) {
      this.$router.push('/purchase/detail/' + id)
    },
    getEdit(id) {
      this.$router.push('/purchase/edit/' + id)
    },
    getPrinter(id) {
      window.open('https://www.pharmacare-plus.com/purchaseorderpdf/' + id, '_blank')
    },
    order_approved(id) {
      this.loading_page = true
      HTTP.get('/purchaseorders/approve/' + id)
        .then((res) => {
          if (res.data.success === true) {
            setTimeout(() => this.alert_success = false, 2000);
            this.getPurchaseAll();
          }
        })
    },
    cancel_po(id) {
      this.cancel_modal.cancel_id = id
      this.po_cancel = true
    },
    save_cancel_po() {
      HTTP.post('/purchaseorders/cancelpo', {
        po_id: this.cancel_modal.cancel_id,
        cancel_note: this.cancel_modal.cancel_note
      }).then((res) => {
        if (res.data.success === true) {
          this.po_cancel = false
          this.cancel_modal.cancel_id = null
          this.cancel_modal.cancel_note = null
          this.alert_success = true
          setTimeout(() => this.alert_success = false, 2000)
          this.getPurchaseAll()
        }
      })
    },
    ChangeStatus(id, status) {
      if (status == false) {
        status = 0
      }
      else if (status == true) {
        status = 1
      }
      HTTP.post('/purchaseorders/updatestatus', {
        po_id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 2000);
          this.getPurchaseAll();
        }
      })
    },
    getDelete(id) {
      HTTP.post('/purchaseorders/deletepo', {
        po_id: id
      }).then((res) => {
        if (res.data.success === true) {
          Swal.fire('ลบข้อมูลเรียบร้อย', '', 'success');
          this.getPurchaseAll();
        }
      });
    },
  },
  beforeMount() {
    this.page(1);
  }
}
</script>

<style lang="scss">
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
</style>
